import React from "react";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";

import Avatar from "../../Avatar/Avatar";
import Card from "../../UI/Card/Card";

import * as ContactUtils from "../../Utils/ContactUtils";

import LogService from "../../../middleware/CommonSdk/LogService";

const LOG_TAG = "SETTINGS-USER-INFORMATIONS";

const UserInformations = (props) => {

    LogService.info(LOG_TAG, "UserInformations");

    const intl = useIntl();
    const user = useSelector(state => state.contacts.user);

    const userName = ContactUtils.getDisplayName(user);
    const companyName = ContactUtils.getCompanyName(user);
    const rainbowAccount = ContactUtils.getLoginEmail(user);
    const avatar = ContactUtils.getAvatar(user);
    const userRole = ContactUtils.getUserRole(user);

    return (
        <Card title={intl.messages.myProfile}>
            <div className="row">
                <div className="col-md-8">
                    <div className="form-group">
                        <label className="input-label" htmlFor="inputUsername">{intl.messages.username}</label>
                        <input id="inputUsername" placeholder="Username" type="text" className="form-control" autoComplete="off" disabled
                            value={userName}
                        ></input>
                    </div>
                    <div className="form-group">
                        <label className="input-label" htmlFor="inputAccount">{intl.messages.rainbowAccount}</label>
                        <input id="inputAccount" placeholder="Rainbow account" type="text" className="form-control" autoComplete="off" disabled
                            value={rainbowAccount}
                        ></input>
                    </div>
                    <div className="form-group">
                        <label className="input-label" htmlFor="inputCompany">{intl.messages.company}</label>
                        <input id="inputCompany" placeholder="Company" type="text" className="form-control" autoComplete="off" disabled
                            value={companyName}
                        ></input>
                    </div>
                    <div className="form-group">
                        <label className="input-label" htmlFor="inputRole">{intl.messages.role}</label>
                        <input id="inputRole" placeholder="Role" type="text" className="form-control text-truncate" autoComplete="off" disabled
                            value={userRole}
                        ></input>
                    </div>

                </div>
                <div className="col-md-4">
                    <div className="text-center">
                        <Avatar name={userName} avatar={avatar} />

                        {/* <div className="mt-3 mb-3">
                            <Button
                                className="btn-submit"
                                label={intl.messages.upload}
                                icon={faUpload}
                                disabled={true}
                            />

                            <div className="panel bg-fog mt-2">
                            JPG or PNG, <br/>min size 500x500
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
        </Card>
    );
}

export default UserInformations;